import React, { Component } from 'react'
import ArtistList from './artist-list'

class ArtistListContainer extends Component {
  componentDidMount() {
    const { onStartup, artists, fetching } = this.props
    if (!fetching && !artists) {
      onStartup && onStartup()
    }
  }

  render() {
    const { artists, enabled, forceEnabled, onArtistClick } = this.props 
    const artistEnabled = enabled || forceEnabled
    const displayProp = artistEnabled ? 'block' : 'none'
    
    return (
      <div style={{ display: displayProp }} className="artist-list-container">
        <ArtistList onArtistClick={onArtistClick} artists={artists} />
      </div>
    )
  }
}

export default ArtistListContainer


// WEBPACK FOOTER //
// ./src/components/artist-list-container/artist-list-container.js